export default class BtnCheck {
    static init(): void {
        const btns: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.btn-check');

        if (btns.length > 0) {
            btns.forEach((btn: HTMLAnchorElement) => {
                btn.addEventListener('click', () => {
                    const titleBefore = btn.querySelector('.btn-check__title-before');
                    const titleAfter = btn.querySelector('.btn-check__title-after');

                    if (titleBefore && titleAfter) {
                        btn.classList.toggle('btn-check--checked');
                    }
                });
            });
        }
    }
}
